var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.563 4.45502C19.3388 4.23031 19.0345 4.10403 18.717 4.10403C18.3996 4.10403 18.0952 4.23031 17.871 4.45502L12.003 10.311L6.13504 4.44302C5.91084 4.21831 5.60646 4.09203 5.28904 4.09203C4.97162 4.09203 4.66724 4.21831 4.44304 4.44302C3.97504 4.91102 3.97504 5.66702 4.44304 6.13502L10.311 12.003L4.44304 17.871C3.97504 18.339 3.97504 19.095 4.44304 19.563C4.91104 20.031 5.66704 20.031 6.13504 19.563L12.003 13.695L17.871 19.563C18.339 20.031 19.095 20.031 19.563 19.563C20.031 19.095 20.031 18.339 19.563 17.871L13.695 12.003L19.563 6.13502C20.019 5.67902 20.019 4.91102 19.563 4.45502Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.e432d630da6496370f332df1b733907c.svg";
export { ForwardRef as ReactComponent };